import { ApolloError } from '@apollo/client';
import { ParsedPromo, ParsedXPPromo } from '../../components/Layout/Promotions/types';

export type ParsedPlatformPromos = {
  plPromos: ParsedXPPromo[];
  rewardsPromos: ParsedPromo[];
  userTags: Nullable<UserTags>;
};

export type PlatformPromos = {
  platformPromos: ParsedPlatformPromos;
  isPromosLoading: boolean;
  promosLoadingError: unknown | ApolloError;
};

export enum PromoTagCategory {
  BONUS = 'Bonus',
}

export type UserTag = { tagId: string | null | undefined; tagName: string | null | undefined };
export type UserTags = UserTag[] | undefined;
